export const SUB_SIDEBAR_KEYS = {
  UPLOAD: 'upload',
  AI_IMAGE: 'ai-image',
  AI_VIDEO: 'ai-video',
  AUDIO: 'audio',
  TTS: 'tts',
  IMAGE: 'image',
  AI_LIB: 'ai-library'
}

export const OVERLAY_KEYS = {
  aiVideo: 'aiVideo',
  aiImage: 'aiImage',
  image: 'image'
}

export const OVERLAY_MAX_WIDTH = 380
